export var SCENE_IDS = {
    SUBMIT_FLOW: 'submit_flow',
};
